export default __webpack_public_path__ + "static/media/rd9.37f3a755.png";